<template>
  <div>
    <div class="ready_banner" style="height: auto; padding-bottom:18px;">
      <div class="star_banner_top">
        <p class="font18 colorWhite">{{examPaperInfo.title}}</p>
        <div class="star_banner_right">
        </div>
      </div>
      <div class="star_banner_content">
        <div class="star_banner_content_left">
          <p class="star_banner_content_left_top">完成<span class="pingfen_left_top_red"> {{completeNum}} </span>/ {{questionCnt}}题</p>
          <div class="star_banner_content_left_two">
            <div class="grayDiv"></div><span class="mr13">未做</span>
            <div class="redDiv"></div><span class="mr13">已做</span>
            <img class="mr6" src="@/assets/images/kaoshi_start.jpg"/><span class="mr13">标记</span>
            <div class="grayboldDiv"></div><span>当前</span>
          </div>

          <div class="star_banner_content_left_list">
            <p class="font14 colorBlack mb12">所有题目</p>
            <div style="display: flex;flex-direction: row;margin-bottom: 24px;">
              <div v-for="(item, index) in examPaperQInfo" :key="item.id" @click="getQuestion(index, item)" :class="{'redDivTwentyThree': item.mark=='0' && (questionIndex!=index), 'biaojiDivTwentyThree': item.mark=='1' && (questionIndex!=index), 'grayDivTwentyThree': item.mark=='2' && (questionIndex!=index), 'grayboldDivTwentyThree': (questionIndex==index)&&(item.mark=='1')||(questionIndex==index)&&(item.mark=='2')||(questionIndex==index)&&(item.mark=='0') }">{{index+1}}</div>
            </div>
          </div>

        </div>
        <div class="star_banner_content_Right_two" >
          <!--单选题-->
          <div class="star_banner_content_Right_top" v-if="question.questionType=='selection'">
            <p class="font18 colorBlack mt34 mb40">{{questionIndex+1}}.{{question.questionInfoList.description}}<span class="colorBlue">（单选）</span></p>
            <p class="font14 colorBlack mb25 displayFlex" v-for="item in question.answerInfoList" :key="item.id"><input type="radio" name="timu" :id="item.id" :value="item.no" v-model="selectOption" disabled/><span class="marginSpan">{{String.fromCharCode(65 + parseInt(item.no))}}.</span> {{item.description}}</p>
          </div>
          <!--/单选题-->
          <!--多选题-->
          <div class="star_banner_content_Right_top" v-if="question.questionType=='multiSelection'">
            <p class="font18 colorBlack mt34 mb40">{{questionIndex+1}}.{{question.questionInfoList.description}}<span class="colorBlue">（多选）</span></p>
            <p class="font14 colorBlack mb25 displayFlex" v-for="item in question.answerInfoList" :key="item.id"><input type="checkbox" style="opacity: 1" name="timu" :id="item.id" :value="item.no" v-model="multiSelectOption" disabled/><span class="marginSpan">{{String.fromCharCode(65 + parseInt(item.no))}}.</span> {{item.description}}</p>
          </div>
          <!--/多选题-->
          <!--判断题-->
          <div class="star_banner_content_Right_top" v-if="question.questionType=='judgement'">
            <p class="font18 colorBlack mt34 mb40">{{questionIndex+1}}.{{question.questionInfoList.description}}<span class="colorBlue">（判断）</span></p>
            <p class="font14 colorBlack mb25 displayFlex" v-for="item in question.answerInfoList" :key="item.id"><input type="radio" name="timu" :id="item.id" :value="item.no" v-model="selectOption" disabled/><span class="marginSpan">{{String.fromCharCode(65 + parseInt(item.no))}}.</span> {{item.description}}</p>
          </div>
          <!--/判断题-->
          <!--简答题-->
          <div class="star_banner_content_Right_top" v-if="question.questionType=='short'">
            <p class="font18 colorBlack mt34 mb40">{{questionIndex+1}}.{{question.questionInfoList.description}}<span class="colorBlue">（简答题）</span></p>
            <textarea class="text_con" placeholder="请输入您的答案" v-model="shortAnswer" readonly></textarea>
          </div>
          <!--/简答题-->
          <!--填空题-->
          <div class="star_banner_content_Right_top" v-show="question.questionType=='write'">
            <p class="font18 colorBlack mt34 mb40">
              {{questionIndex+1}}.
              <a id="write_description"></a>
              <span class="colorBlue">（填空题）</span></p>
          </div>
          <!--/填空题-->
          <div class="star_banner_content_Right_bottom">
            <p class="font14 colorBlack" v-if="question.questionType=='short' || question.questionType=='write'"><span></span></p>
            <p class="font14 colorBlack" v-if="question.questionType=='selection' || question.questionType=='judgement'">您的选择是：<span class="redColor" v-if="selectOption && selectOption!=''">{{String.fromCharCode(65 + parseInt(selectOption))}}</span></p>
            <p class="font14 colorBlack" v-if="question.questionType=='multiSelection'">您的选择是：<span class="redColor">{{ AscToString(multiSelectOption) }}</span></p>
            <div style="display: flex;flex-direction: row;align-items: center;">
              <p class="font14 colorBlack"><input type="checkbox" style="opacity:1" name="biaoji" :checked="answerParams.mark=='1'" value="1" disabled/> 标记</p>
              <a href="javascript:;" class="star_banner_content_Right_bottom_a" v-if="questionIndex>0" @click="getQuestionByBtn('prev', questionIndex)">上一题</a>
              <a href="javascript:;" class="star_banner_content_Right_bottom_a" v-if="questionIndex<questionCnt-1" @click="getQuestionByBtn('next', questionIndex)">下一题</a>
            </div>
          </div>
          <div>
            <p class="font18 colorBlack mt34 ml36">答案解析：</p>
            <div class="shijuan_analysis">
              <p class="font14 colorGreen" v-if="question.questionType=='short' || question.questionType=='write'">正确答案：&nbsp;&nbsp;<span class="redColor">{{question.answer}}</span></p>
              <p class="font14 colorGreen" v-if="question.questionType=='selection' || question.questionType=='judgement'">正确答案：&nbsp;&nbsp;<span class="redColor" v-if="selectOption && selectOption!=''">{{String.fromCharCode(65 + parseInt(question.answer))}}</span></p>
              <p class="font14 colorGreen" v-if="question.questionType=='multiSelection'">正确答案：&nbsp;&nbsp;<span class="redColor">{{ AscToString(question.answer) }}</span></p>
              <p class="font12 colorBlack">{{question.thinkingInfoList.description}}</p>
              <img :src="question.thinkingInfoList.uri" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-dialog/>
  </div>
</template>
<script>
  import countDown from '@/components/common/countDown/countDown.vue'
  export default {
    components: { countDown },
    data () {
      return {
        paperId: this.$route.params.id,
        examId: this.$route.params.examId,
        infoId: this.$route.params.infoId,
        examPaperInfo: {},
        examPaperQInfo: [],
        question: {
          thinkingInfoList: {}
        },
        seconds: '',
        timerStatus: false,
        questionIndex: 0,
        selectOption: '', // 单选题目答案
        multiSelectOption: [], // 多选题目答案
        shortAnswer: '', // 简答题答案
        questionCnt: 0, // 题目总数
        completeNum: 0, // 题目完成数
        answerParams: {
          id: '',
          examId: this.$route.params.examId,
          paperId: this.$route.params.id,
          isFinish: '0',
          questionId: '',
          answer: '',
          mark: '',
          examStart: ''
        }
      }
    },
    created () {
      this.getExamPaper(this.paperId, this.examId)
    },
    mounted () {
      this.$nextTick(() => {
      })
    },
    methods: {
      AscToString (arr) {
        var answerStr = ''
        var arr_sort = arr.slice(0)
        for (let i=0; i<arr_sort.length; i++) {
          answerStr += String.fromCharCode(65 + parseInt(arr_sort[i]))
        }
        return answerStr
      },
      getExamPaper (id, examId) {
        this.$api.post(this.$global.examApiPath, '/examPaper/getByExam', {id: id, examId: examId}, r => {
          if (r.data) {
            this.examPaperInfo = r.data
          }
        })
        this.$api.post(this.$global.examApiPath, '/examExamScoreInfo/search', {examId: examId}, r => {
          if (r.data) {
            this.questionCnt = r.cntData
            if (r.data && r.data.length>0) {
              this.examPaperQInfo = r.data
              this.completeNum = this.completeQuestions(this.examPaperQInfo)
              for (let i=0; i<this.examPaperQInfo.length; i++) {
                if (this.examPaperQInfo[i].id == this.infoId) {
                  this.questionIndex = i
                }
                this.answerParams.id = this.infoId
              }
              this.$api.post(this.$global.examApiPath, '/examQuestion/getByExam', {infoId: this.infoId, getAnswer: '1'}, r => {
                if (r.data) {
                  this.question = r.data
                  this.answerParams.mark = this.question.mark
                  this.answerParams.questionId = this.question.id
                  this.answerParams.examStart = this.question.examStart
                  if (this.question.questionType == 'write') {
                    this.dealAnswer(this.question.questionType, this.question.infoAnswer, this.question.questionInfoList.description)
                  } else {
                    this.dealAnswer(this.question.questionType, this.question.infoAnswer)
                  }
                }
              })
            }
          }
        })
      },
      completeQuestions (list) {
        let num = 0;
        for (let i = 0; i < list.length; i++) {
          if (list[i].mark != '2') {
            num++;
          }
        }
        return num;
      },
      // 左侧列表切换试题
      getQuestion (index, item) {
        if (this.questionIndex != index) {
          this.dealOptions(this.question.questionType)
          this.setMarkState(this.answerParams, this.question.questionType)
          this.$api.post(this.$global.examApiPath, '/examExamScoreInfo/search', {examId: this.examId}, r => {
            if (r.data) {
              this.questionCnt = r.cntData
              if (r.data && r.data.length > 0) {
                this.examPaperQInfo = r.data
                this.completeNum = this.completeQuestions(this.examPaperQInfo)
                this.questionIndex = index
                this.getQuestionInfo(item.id)
              }
            }
          })
        }
      },
      // 左右按钮切换试题
      getQuestionByBtn (type) {
        var index;
        if (type=='prev') {
          index = this.questionIndex - 1
        } else if (type=='next') {
          index = this.questionIndex + 1
        }
        this.getQuestion(index, this.examPaperQInfo[index])
      },
      setMarkState (params, qType) {
        if (qType != 'write') {
          if (params.answer == '' && params.mark != '1') {
            params.mark = '2';
          } else if (params.answer != '' && params.mark != '1') {
            params.mark = '0';
          } else if (params.answer == '' && params.mark == '1') {
            params.mark = '1';
          } else if (params.answer != '' && params.mark == '1') {
            params.mark = '1';
          }
        } else if (qType == 'write') {
          var answerList = this.$utils.bracketText(params.answer);
          var writeStatus = false
          for (let i=0; i<answerList.length; i++) {
            if (answerList[i]!= '') {
              writeStatus = true
              break;
            }
          }
          if (!writeStatus && params.mark != '1') {
            params.mark = '2';
          } else if (writeStatus && params.mark != '1') {
            params.mark = '0';
          } else if (!writeStatus && params.mark == '1') {
            params.mark = '1';
          } else if (writeStatus && params.mark == '1') {
            params.mark = '1';
          }
        }
      },
      getQuestionInfo (id) {
        this.selectOption = ''
        this.multiSelectOption = []
        this.shortAnswer = ''
        this.answerParams = {
          id: id,
          examId: this.examId,
          paperId: this.paperId,
          isFinish: '0',
          questionId: '',
          answer: '',
          mark: '',
          examStart: ''
        }
        this.$api.post(this.$global.examApiPath, '/examQuestion/getByExam', {infoId: id, getAnswer: '1'}, r => {
          if (r.data) {
            this.question = r.data
            this.answerParams.mark = this.question.mark
            this.answerParams.questionId = this.question.id
            this.answerParams.examStart = this.question.examStart
            if (this.question.questionType == 'write') {
              this.dealAnswer(this.question.questionType, this.question.infoAnswer, this.question.questionInfoList.description)
            } else {
              this.dealAnswer(this.question.questionType, this.question.infoAnswer)
            }
          }
        })
      },
      dealAnswer (type, answer, writeStr) {
        switch (type) {
          case 'selection':
            this.selectOption = answer
            this.answerParams.answer = answer
            break;
          case 'multiSelection':
            this.multiSelectOption = answer.split('');
            break;
          case 'write':
            var replaceStr = '(<input type="text" class="tktext" value="" readonly/>)'
            $('#write_description').html(this.$utils.bracketReplace(writeStr, replaceStr));
            if (writeStr && writeStr!='') {
              var answerList = this.$utils.bracketText(answer);
              for (let i = 0; i < answerList.length; i++) {
                $('#write_description').find('.tktext')[i].value = answerList[i];
              }
            }
            break;
          case 'judgement':
            this.selectOption = answer
            this.answerParams.answer = answer
            break;
          case 'short':
            this.shortAnswer = answer
            this.answerParams.answer = answer
            break;
        }
      },
      dealOptions (type) {
        function sortNumber (a, b) {
          return a - b;
        }
        switch (type) {
          case 'selection':
            this.answerParams.answer = this.selectOption
            break;
          case 'multiSelection':
            this.multiSelectOption.sort(sortNumber);
            if (this.multiSelectOption && this.multiSelectOption.length>0) {
              let multiSelectStr = ''
              for (let i=0; i<this.multiSelectOption.length; i++) {
                multiSelectStr+=this.multiSelectOption[i]
              }
              this.answerParams.answer = multiSelectStr
            } else {
              this.answerParams.answer = ''
            }
            break;
          case 'write':
            this.answerParams.answer = this.inputValueDeal('#write_description').inputstr
            break;
          case 'judgement':
            this.answerParams.answer = this.selectOption
            break;
          case 'short':
            this.answerParams.answer = this.shortAnswer
            break;
        }
      },
      inputValueDeal (id) {
        var allInputs = $(id).find('.tktext')
        var inputsValue = [];
        var result = {};
        for (let i = 0; i < allInputs.length; i++) {
          inputsValue.push($(allInputs[i]).val());
        }
        for (let j = 0; j < allInputs.length; j++) {
          $(allInputs[j]).after(inputsValue[j]);
        }
        for (let k = 0; k < inputsValue.length; k++) {
          if (inputsValue[k] == '') {
            result.isNull = true;
            break;
          } else {
            result.isNull = false;
          }
        }
        $(id).find('.tktext').remove();
        result.inputstr = $(id).html();
        return result;
      }
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/modules/exam/analysis.vue